export enum MenuItemType {
    Separator = 1,
    Group = 2,
    Item = 3
  }